import io from "socket.io-client";
import { API_URL } from "../api";

export const socket = io.connect(`${API_URL}`, {
  transports: ["websocket", "polling", "flashsocket"],
});
